import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NlpRoutingModule } from './nlp-routing.module';
import { NlpExampleComponent } from './nlp-example/nlp-example.component';
import { NlpQuestionComponent } from './nlp-question/nlp-question.component';
import { NlpComponent } from './nlp.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { WordsegmentComponent } from './wordsegment/wordsegment.component';

@NgModule({
  declarations: [
    NlpExampleComponent,
    NlpQuestionComponent,
    NlpComponent,
    LoadingSpinnerComponent,
    WordsegmentComponent
  ],
  imports: [
    CommonModule,
    NlpRoutingModule,
    FormsModule,
    ProgressSpinnerModule
  ],
  exports: [
    WordsegmentComponent 
  ]
})
export class NlpModule { }
